module.exports = __webpack_public_path__ + "static/media/img-9.8c6c9c8e.jpg";